import 'react-app-polyfill/ie11'

import 'core-js/es/map'
import 'core-js/es/set'
import 'raf/polyfill'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import configureStore from './configureStore'
import Root from './Root'
import Announcer from 'containers/Announcer'
import ApolloClient from 'apollo-boost'
import { ApolloProvider } from 'react-apollo'
import DevRouter from './DevRouter'
import PropTypes from 'prop-types'
import { LocaleProvider } from 'antd'
import frFR from 'antd/lib/locale-provider/fr_FR'
import 'antd/dist/antd.css'
import './index.less'
import { signOut } from './actions/auth'
import { flashWarning } from './actions/flash'
import localization from './utils/localization'
import { BrowserRouter } from 'react-router-dom'

function initStores (BRAND_TOKEN) {
  const { store, persistor } = configureStore({ brand: { brand_token: BRAND_TOKEN } })
  const client = new ApolloClient({
    uri: `${process.env.REACT_APP_API_BASE}/graphql`,
    request: async operation => {
      const token = store.getState().auth.token

      operation.setContext({
        headers: {
          authorization: `Bearer ${token}`,
          'X-Brand': BRAND_TOKEN
        }
      })
    },
    onError: ({ networkError }) => {
      if (networkError && networkError.statusCode === 401) {
        store.dispatch(signOut())
        store.dispatch(
          flashWarning({
            message: localization.auth.sessionExpired.title,
            description: localization.auth.sessionExpired.description
          })
        )
        setTimeout(() => {
          window.location = process.env.REACT_APP_SIGN_IN_PATH
        }, 0)
      }
    }
  })
  return { store, persistor, client }
}

const BRAND_TOKEN = document.querySelector('[data-brand]') ? document.querySelector('[data-brand]').attributes['data-brand'].value : 'NFcZwKiipFH4Hi1w4W9u6E9u'

const { store, persistor, client } = initStores(BRAND_TOKEN)

const newDiv = document.createElement('div')
document.body.appendChild(newDiv)

const Wrapper = ({ children }) => {
  return (
    <BrowserRouter>
      <LocaleProvider locale={frFR}>
        <ApolloProvider client={client}>
          <Provider store={store} >
            <PersistGate loading={null} persistor={persistor}>
              {children}
            </PersistGate>
          </Provider>
        </ApolloProvider>
      </LocaleProvider>
    </BrowserRouter>
  )
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Announcer />
    </PersistGate>
  </Provider>,
  newDiv,
  // Component Announcer must be rendered before any other component
  // Hence this callback
  () => {
    if (process.env.NODE_ENV === 'development') {
      ReactDOM.render(
        <Wrapper>
          <DevRouter />
        </Wrapper>,
        document.getElementById('root')
      )
    } else {
      [...document.querySelectorAll('[data-component]')].forEach(container => {
        const component = container.attributes['data-component'].value
        
        ReactDOM.render(
          <Wrapper>
            <Root component={component} />
          </Wrapper>,
          container
        )
      })
    }
  }
)

Wrapper.propTypes = {
  children: PropTypes.element.isRequired
}
